import { FC, ReactNode } from "react";
import { Link } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import classNames from "classnames";
import logo from "../../../assets/images/logo.svg";
import googlePlay from "../../../assets/images/google-play.svg";
import appStore from "../../../assets/images/apple-store.svg";
import { ROUTES } from "../../../routes";
import Title from "../../atoms/Title/Title";
import SubHeader from "../../atoms/SubHeader/SubHeader";
import styles from "./styles.module.scss";

type PropsT = {
  children: ReactNode;
  wide?: boolean;
  split?: boolean;
  logos?: boolean;
  onGoBack?: VoidFunction;
};

export const LoginScreenLayout: FC<PropsT> = ({
  children,
  wide,
  logos,
  split = true,
  onGoBack,
}) => {
  const showLogos = logos && !Capacitor.isNativePlatform();

  return (
    <div className={styles.layout}>
      {onGoBack && <SubHeader isDetail title="Back" onGoBack={onGoBack} />}
      <div className="container-fluid">
        <div className={classNames(split && "grid")}>
          <div className={classNames(split && "g-col-12 g-col-lg-5")}>
            <div
              className={classNames(
                styles.wrapper,
                split && wide && styles["wrapper-wide"],
                split && !wide && styles["wrapper-small"]
              )}
            >
              <div className={styles.form}>
                <Link to="/">
                  <img
                    className={classNames("d-block mx-auto", styles.logo)}
                    src={logo}
                    alt="Spider Autonomous logo"
                    width="186"
                    height="169"
                  />
                </Link>
                {children}
              </div>
              <div>
                {showLogos && !Capacitor.isNativePlatform() && (
                  <div className={styles.storeLogos}>
                    <a href="https://play.google.com/store/apps/details?id=tech.smaut.app.second">
                      <img src={googlePlay} alt="Google Play logo" />
                    </a>
                    <a href="https://apps.apple.com/us/app/automowing/id6497876939">
                      <img src={appStore} alt="Apple Store logo" />
                    </a>
                  </div>
                )}
                <div className={styles.footer}>
                  <a href="mailto:info@spidernewtech.com">Support</a> |{" "}
                  <Link to={ROUTES.privacy()}>Privacy</Link>
                </div>
              </div>
            </div>
          </div>
          {split && (
            <div className="g-col-12 g-col-lg-7 d-none d-lg-block">
              <div className={styles.background}>
                <aside className={styles.aside}>
                  <Title className={styles.asideTitle} type="h2">
                    AutoMowing
                  </Title>
                  <p>the smart solution for autonomous maintenance</p>
                </aside>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
